export const PRIVATE_TOP_PATH = '/themes';
export const LOGIN_PATH = '/auth/login';
